import axios from "axios";
import Auth from "helpers/auth";
import _ from "underscore";

let customAdapter;

export default {
  setAdapter(adapter) {
    customAdapter = adapter;
  },

  instance(options = {}) {
    const instance = axios.create({
      baseURL: process.env.API_BASE_URL,
      timeout: options.timeout || 10000,
      adapter: customAdapter
    });

    instance.defaults.headers.post["Content-Type"] = "application/json";

    const sessionToken = Auth.token();

    if (_.isString(sessionToken) && sessionToken.length) {
      instance.defaults.headers.common.Authorization = `Token ${sessionToken}`;
    }

    return instance;
  }
};
